import Loader from "components/Systems/Loader/Loader";

export default Loader;
